// extracted by mini-css-extract-plugin
module.exports = {"link":"thumbnail-module--link--XHmpP","figure":"thumbnail-module--figure--1S6si","image":"thumbnail-module--image--bsbez","caption":"thumbnail-module--caption--1lUwJ"};